const routes = [
  {
    path: '/contact-lists',
    name: 'contactLists-list',
    component: () => import(/* webpackChunkName: "page/contact-lists/list" */'@/views/pages/contact-lists/List'),
    meta: {
      permissions: 'contact_lists_read'
    }
  },
  {
    path: '/contact-lists/new',
    name: 'contactLists-new',
    component: () => import(/* webpackChunkName: "page/contact-lists/new" */'@/views/pages/contact-lists/New'),
    meta: {
      permissions: 'contact_lists_write'
    }
  },
  {
    path: '/contact-lists/:id',
    name: 'contactLists-single',
    component: () => import(/* webpackChunkName: "page/contact-lists/single" */'@/views/pages/contact-lists/Single'),
    meta: {
      permissions: 'contact_lists_read'
    }
  },
  {
    path: '/contact-lists/:id/edit',
    name: 'contactLists-edit',
    component: () => import(/* webpackChunkName: "page/contact-lists/edit" */'@/views/pages/contact-lists/Edit'),
    meta: {
      permissions: 'contact_lists_write'
    }
  }
]

export default routes
